import React from 'react';
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1';
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader';
import PricingCalculator from '../../Componet/Calculator/Claculator-Hebrew';
import '../Utilities/style.css';

function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"מחשבון עלות"} />
            <div className="page-content">
                <PricingCalculator />

                <div
                    style={{
                        maxWidth: '560px',
                        margin: '32px auto 0',
                        padding: '28px 24px',
                        borderRadius: '18px',
                        background: '#ffffff',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
                        textAlign: 'center'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '18px' }}>
                        <a
                            href="/he"
                            className="stylish-button"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 'auto',
                                minWidth: 'unset',
                                padding: '10px 16px',
                                fontSize: '14px',
                                fontWeight: '600',
                                borderRadius: '999px',
                                textDecoration: 'none',
                                boxShadow: 'none',
                                background: '#f8fafc',
                                color: '#0f172a',
                                border: '1px solid #e2e8f0'
                            }}
                        >
                            המשך לאתר בעברית
                        </a>
                    </div>

                    <div style={{ direction: 'rtl' }}>
                        <h2 style={{ margin: 0, fontSize: '1.6rem', color: '#0f172a', fontWeight: 700 }}>
                            החל מ-₪149 לחודש
                        </h2>
                        <p style={{ margin: '8px 0 0', fontSize: '1rem', color: '#64748b' }}>
                            עכשיו אפשר לשלם בתשלומים
                        </p>
                    </div>
                </div>

                <NewsletterL1 />
            </div>
        </>
    );
}

export default TermsConditions;
